import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { cn } from '@/lib/utils'
import { Textarea } from '../primitives/Textarea'
import { Label } from '../primitives/Label'

interface FormTextareaProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  placeholder?: string
  rules?: Record<string, unknown>
  disabled?: boolean
  rows?: number
  className?: string
  showLabel?: boolean
  textareaClassName?: string
}

export function FormTextarea<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  rules,
  disabled = false,
  rows = 4,
  className,
  showLabel = true,
  textareaClassName,
}: FormTextareaProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <div className={cn('flex flex-col gap-2', className)}>
          {showLabel && label && (
            <Label htmlFor={name} required={!!rules?.required}>
              {label}
            </Label>
          )}
          <Textarea
            {...field}
            className={textareaClassName}
            disabled={disabled}
            error={!!fieldState.error}
            id={name}
            placeholder={placeholder}
            rows={rows}
          />
          {fieldState.error && (
            <span className="text-xs text-red-600">
              {fieldState.error.message}
            </span>
          )}
        </div>
      )}
      rules={rules}
    />
  )
}
